import React from 'react'
import PropTypes from 'prop-types'
import Sticky from 'react-stickynode'

import { MenusContainer } from './styled'
import WhiteLabelCategory from './WhiteLabelCategory'
import DesktopContainer from 'layouts/DesktopContainer'
import WhiteLabelMenuList from './WhiteLabelMenuList'
import OrderParty from 'components.v2/OrderParty'
import isNode from 'detect-node'
import WhiteLabelOrder from './WhiteLabelOrder'

const Menus = ({ menus, openModal }) => (
  <DesktopContainer background="white">
    <MenusContainer>
      <div style={{ width: 160, marginTop: 40 }}>
        <Sticky bottomBoundary="#sticky-boundary">
          <div style={{ padding: '40px 0 80px' }}>
            <WhiteLabelCategory categories={menus.map(m => m.name)} />
          </div>
        </Sticky>
      </div>

      <WhiteLabelMenuList
        id="sticky-boundary"
        menus={menus}
        openModal={openModal}
      />

      <div style={{ width: 345 }}>
        <Sticky bottomBoundary="#sticky-boundary">
          {isNode ? null : <OrderParty />}
          <div style={{ paddingBottom: 40 }}>
            <WhiteLabelOrder />
          </div>
        </Sticky>
      </div>
    </MenusContainer>
  </DesktopContainer>
)

Menus.propTypes = {
  openModal: PropTypes.func,
  menus: PropTypes.array,
}

export default Menus
